import React, { useState, useEffect } from 'react';
import {FormattedMessage, useIntl} from 'react-intl';
import ReactMarkdown from 'react-markdown'; // <--- Импорт
import { get } from '../../services/api';
import { usePageLoader } from '../../contexts/PageLoaderContext';
import { useNotifier } from '../../contexts/NotificationContext';
import { useNavigate } from 'react-router-dom';

import Title from '../../components/common/Title/Title';
import styles from './DocumentPage.module.css';
import Card from "../../components/common/Card/Card";
import {showBackButton} from "../../services/telegramService";

const DocumentPage = ({ documentSlug }) => {
    const [documentContent, setDocumentContent] = useState('');
    const { locale } = useIntl();
    const { showPageLoader, hidePageLoader } = usePageLoader();
    const { addNotification } = useNotifier();
    const navigate = useNavigate();

    useEffect(() => {
        showBackButton();
    }, []);

    useEffect(() => {
        showPageLoader();
        // Laravel автоматически выберет нужный язык на основе заголовка Accept-Language
        // Или можно передать явно: get(`documents/${documentSlug}`, { lang: locale })
        get(`documents/${documentSlug}`)
            .then(response => {
                if (response.data) {
                    setDocumentContent(response.data);
                } else {
                    throw new Error('Document content not found.');
                }
            })
            .catch(error => {
                addNotification(error.message, 'error');
                navigate('/settings'); // Возвращаемся, если документ не найден
            })
            .finally(() => {
                hidePageLoader();
            });
    }, [documentSlug, locale, showPageLoader, hidePageLoader, addNotification, navigate]);

    // Получаем заголовок страницы из id локализации
    // например, `privacy-policy` -> `settings.privacyPolicyButton`
    const titleId = {
        'privacy-policy': 'settings.privacyPolicyButton',
        'terms-of-use': 'settings.termsOfUseButton'
    }[documentSlug] || '';

    return (
        <div>
            <Title><FormattedMessage id={titleId} /></Title>
            <Card document={true}>
                <ReactMarkdown>{documentContent}</ReactMarkdown>
            </Card>
        </div>
    );
};

export default DocumentPage;
